import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PhxIconModule, PhxMobileSelectModule, PhxSelectModule } from 'phx-core';

import { HierarchyMultiSelectWithCounterModule } from '@app/misc/hierarchy-multi-select-with-counter/module';
import { GlobalGroupsMultiSelectFilterComponent } from '@app/misc/groups-multi-select-filter/global.component';
import { GroupsMultiSelectFilterComponent } from '@app/misc/groups-multi-select-filter/local.component';

@NgModule({
  imports: [
    CommonModule,
    PhxIconModule,
    FormsModule,
    HierarchyMultiSelectWithCounterModule,
    PhxSelectModule,
    PhxMobileSelectModule,
  ],
  declarations: [
    GroupsMultiSelectFilterComponent,
    GlobalGroupsMultiSelectFilterComponent,
  ],
  exports: [
    GroupsMultiSelectFilterComponent,
    GlobalGroupsMultiSelectFilterComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GroupsMultiSelectFilterModule {}
